// extracted by mini-css-extract-plugin
module.exports = {"mainGrid":"_1nJ3JjZ_xru8rBIm3E5iWF"};